var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"w-full rounded-md border-solid border border-EXPONDO-grey-20 px-4 py-3",attrs:{"bind":_vm.$attrs},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }